module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b08301efa789f34c92da0d7a2edad526.png";